import Portal from 'components/Shared/Portal';
import { Component, createRef, RefObject } from 'react';
import style from './formError.scss';

export default ({ error }: { error: string }) => {
  const selector = () => errorRef.current;
  return (
    <Portal container={selector}>
      <div>{error}</div>
    </Portal>
  );
};

const errorRef: RefObject<HTMLDivElement> = createRef();
export class FormErrorModal extends Component {
  public render() {
    return <div className={style.base} ref={errorRef} />;
  }
}
